import { BaseUrl } from '@/helpers/BaseUrl';
import adminAxios from '@/plugins/axios';
import { defineStore } from 'pinia';

const baseAttachmentUrl = BaseUrl.get('attachment');
const baseAttachmentGroupUrl = BaseUrl.get('attachmentGroup');

export const useMediaStore = defineStore('media', {
  state: () => {
    return {
      files: [],
      selectedFile: null,
      attachmentCategories: [],
      loadAttachmentTypes: false,
    };
  },
  getters: {
    getFiles() {
      return this.files;
    },
    getAttachmentCategories() {
      return this.attachmentCategories;
    },
  },
  actions: {
    async getFilesList(params, loadMore = false) {
      try {
        const response = await adminAxios.get(`${baseAttachmentUrl}/list`, {
          params,
        });

        if (loadMore) {
          this.files.push(...response.data.data);
        } else {
          this.files = response.data.data;
        }

        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async deleteFile(id = null, uuid = null) {
      try {
        const response = await adminAxios.delete(`${baseAttachmentUrl}/${id}?uuid=${uuid}`);

        this.files.forEach((file, index) => {
          if (file.id == id) {
            this.files.splice(index, 1);
          }
        });

        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },

    async saveFiles(params, id = null, uuid = null, config = null) {
      try {
        if (id && uuid) {
          const response = await adminAxios.post(`${baseAttachmentUrl}/${id}?uuid=${uuid}`, params);

          this.files.forEach((file, index) => {
            if (file.id == id) {
              this.files[index] = response.data.data;
            }
          });

          return response;
        }

        return await adminAxios.post(`${baseAttachmentUrl}`, params, config);
      } catch (error) {
        return await Promise.reject(error);
      }
    },

    async getAllAttachmentCategories(params) {
      try {
        this.loadAttachmentTypes = true;

        const response = await adminAxios.get(`${baseAttachmentGroupUrl}/list`, { params });

        this.attachmentCategories = response.data.data;
        this.loadAttachmentTypes = false;

        return response;
      } catch (error) {
        return await Promise.reject(error);
      }
    },

    async deleteAttachmentCategory(id = null, uuid = null) {
      try {
        return await adminAxios.delete(`${baseAttachmentGroupUrl}/${id}?uuid=${uuid}`);
      } catch (error) {
        return await Promise.reject(error);
      }
    },

    async saveAttachmentCategory(params, id = null, uuid = null) {
      try {
        if (id && uuid) {
          return await adminAxios.put(`${baseAttachmentGroupUrl}/${id}?uuid=${uuid}`, params);
        }

        return await adminAxios.post(`${baseAttachmentGroupUrl}`, params);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
  },
});
